"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("../../../assets/styles/config");
exports.StyledText = styled_components_1.default.h1 `
  font: Bold ${config_1.fontSizes.large} ${config_1.fontFamilies.primary};
  text-align: center;

  @media ${config_1.device.tablet} {
    margin-top: -55px;
  }

  @media ${config_1.device.laptop} {
    font: Bold ${config_1.fontSizes.extraLarge} ${config_1.fontFamilies.primary};
    margin-top: -15px;
  }

  @media ${config_1.device.laptopLarge} {
    font: Bold ${config_1.fontSizes.huge} ${config_1.fontFamilies.primary};
  }
`;
